import { ErrorHandler, Injectable, NgZone, inject, Injector } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
    private readonly ngZone = inject(NgZone);
    private readonly injector = inject(Injector);

    handleError(error: any): void {
        const errorMsg = error?.message || error?.stack || '';

        const isChunkLoadError =
            /Loading chunk [\d]+ failed/.test(errorMsg) ||
            errorMsg.includes('Failed to fetch dynamically imported module') ||
            errorMsg.includes('text/html');

        if (isChunkLoadError) {
            console.warn('Detectado fallo de carga de módulo por nueva versión. Recargando...');

            this.ngZone.runOutsideAngular(() => {
                if (!sessionStorage.getItem('reload_attempted')) {
                    sessionStorage.setItem('reload_attempted', 'true');
                    this.mostrarSnackBarActualizacion();
                }
            });
            return;
        }

        console.error(error);
    }

    private mostrarSnackBarActualizacion() {
        try {
            const snackBar = this.injector.get(MatSnackBar);

            const snackBarRef = snackBar.open(
                '🚀 Nueva versión disponible. Para evitar interrupciones al navegar entre módulos actualice.',
                'Actualizar ahora',
                {
                    duration: 0,
                    horizontalPosition: 'center',
                    verticalPosition: 'bottom',
                    panelClass: ['snackbar-actualizacion']
                }
            );

            snackBarRef.onAction().subscribe(() => {
                sessionStorage.removeItem('reload_attempted');
                window.location.reload();
            });
        } catch (e) {
            window.location.reload();
        }
    }
}